"use client";

import { useState, type FormEvent } from "react";
import Link from "next/link";
import { BrandMark } from "@/components/BrandMark";
import { ThemeToggle } from "@/components/ThemeToggle";
import { Button, Input } from "@/components/ui";

export default function EsqueciSenhaPage() {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  async function submit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    setError("");
    setMessage("");
    setLoading(true);
    try {
      const response = await fetch("/api/v1/session/password-recovery", {
        method: "POST",
        credentials: "include",
        headers: { "content-type": "application/json", accept: "application/json" },
        body: JSON.stringify({ email }),
      });
      if (!response.ok) throw new Error("Não foi possível enviar o pedido. Tente novamente.");
      setMessage("Se houver uma conta local associada ao endereço, enviaremos as instruções.");
    } catch (reason) {
      setError(reason instanceof Error ? reason.message : "Não foi possível enviar o pedido.");
    } finally {
      setLoading(false);
    }
  }

  return (
    <main className="login-shell grid lg:grid-cols-[minmax(280px,42%)_1fr]">
      <aside className="login-hero relative hidden overflow-hidden px-10 py-12 text-white lg:flex lg:flex-col lg:justify-between">
        <BrandMark invert />
        <div className="relative z-10 max-w-md space-y-4">
          <p className="text-xs font-semibold tracking-[0.18em] text-[#36A9E0] uppercase">Conta local</p>
          <h1 className="text-4xl font-bold tracking-tight text-white">Recupere seu acesso</h1>
          <p className="text-base leading-relaxed text-white/80">Enviaremos instruções para redefinir sua senha.</p>
        </div>
        <p className="relative z-10 text-xs text-white/55">Grupo ASV · Portal de serviços</p>
      </aside>
      <section className="relative flex min-h-screen flex-col px-4 py-6 sm:px-8 sm:py-8 lg:px-12 lg:py-10">
        <div className="mb-6 flex items-start justify-between gap-4 lg:mb-8">
          <div className="lg:hidden"><BrandMark /></div>
          <div className="ml-auto"><ThemeToggle /></div>
        </div>
        <div className="mx-auto flex w-full max-w-md flex-1 flex-col justify-center gap-8">
          <header className="space-y-2">
            <p className="text-xs font-semibold tracking-[0.16em] text-[var(--muted)] uppercase">Portal ASV</p>
            <h2 className="text-2xl font-semibold tracking-tight sm:text-3xl">Esqueci minha senha</h2>
            <p className="text-sm leading-relaxed" style={{ color: "var(--muted)" }}>
              Informe seu e-mail. Se houver uma conta local, enviaremos um link válido por 30 minutos.
            </p>
          </header>
          <div className="login-card rounded-xl p-6 sm:p-8">
            <form className="flex flex-col gap-5" onSubmit={submit}>
              <Input
                label="E-mail"
                id="recovery-email"
                type="email"
                autoComplete="email"
                required
                value={email}
                onChange={(event) => setEmail(event.target.value)}
                placeholder="seu@email.com"
              />
              {message ? <p role="status" className="notice success">{message}</p> : null}
              {error ? <p role="alert" className="notice error">{error}</p> : null}
              <Button type="submit" variant="primary" loading={loading} className="w-full">
                Enviar instruções
              </Button>
              <Link href="/entrar" className="text-center text-sm underline">Voltar para entrar</Link>
            </form>
          </div>
        </div>
      </section>
    </main>
  );
}
